/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type GetAssetGenericQueryVariables = Types.Exact<{
	input: Types.AssetInput;
}>;

export type GetAssetGenericQuery = {
	__typename?: "Query";
	asset?:
		| {
				__typename?: "CommodityAsset";
				id: string;
				idInternal: number;
				pid: string;
				symbol: string;
				name: string;
				price: { value: string; precision: number };
				logos: Array<{
					__typename?: "Image";
					height: number;
					mimeType: string;
					theme?: Types.UiTheme | null;
					url: string;
					width: number;
				}>;
		  }
		| {
				__typename?: "CryptoAsset";
				id: string;
				idInternal: number;
				pid: string;
				symbol: string;
				name: string;
				price: { value: string; precision: number };
				logos: Array<{
					__typename?: "Image";
					height: number;
					mimeType: string;
					theme?: Types.UiTheme | null;
					url: string;
					width: number;
				}>;
		  }
		| {
				__typename?: "EquityComplexEtfAsset";
				id: string;
				idInternal: number;
				pid: string;
				symbol: string;
				name: string;
				price: { value: string; precision: number };
				logos: Array<{
					__typename?: "Image";
					height: number;
					mimeType: string;
					theme?: Types.UiTheme | null;
					url: string;
					width: number;
				}>;
		  }
		| {
				__typename?: "EquityEtcAsset";
				exchangeId: string;
				id: string;
				idInternal: number;
				pid: string;
				symbol: string;
				name: string;
				price: { value: string; precision: number };
				metrics?: { __typename?: "EtpAssetMetrics"; isin: string } | null;
				logos: Array<{
					__typename?: "Image";
					height: number;
					mimeType: string;
					theme?: Types.UiTheme | null;
					url: string;
					width: number;
				}>;
		  }
		| {
				__typename?: "EquityEtfAsset";
				exchangeId: string;
				id: string;
				idInternal: number;
				pid: string;
				symbol: string;
				name: string;
				price: { value: string; precision: number };
				metrics?: { __typename?: "EtpAssetMetrics"; isin: string } | null;
				logos: Array<{
					__typename?: "Image";
					height: number;
					mimeType: string;
					theme?: Types.UiTheme | null;
					url: string;
					width: number;
				}>;
		  }
		| {
				__typename?: "EquityRightAsset";
				id: string;
				idInternal: number;
				pid: string;
				symbol: string;
				name: string;
				price: { value: string; precision: number };
				logos: Array<{
					__typename?: "Image";
					height: number;
					mimeType: string;
					theme?: Types.UiTheme | null;
					url: string;
					width: number;
				}>;
		  }
		| {
				__typename?: "EquityStockAsset";
				exchangeId: string;
				id: string;
				idInternal: number;
				pid: string;
				symbol: string;
				name: string;
				price: { value: string; precision: number };
				metrics?: { __typename?: "StockAssetMetrics"; isin: string } | null;
				logos: Array<{
					__typename?: "Image";
					height: number;
					mimeType: string;
					theme?: Types.UiTheme | null;
					url: string;
					width: number;
				}>;
		  }
		| {
				__typename?: "EtfAsset";
				id: string;
				idInternal: number;
				pid: string;
				symbol: string;
				name: string;
				price: { value: string; precision: number };
				logos: Array<{
					__typename?: "Image";
					height: number;
					mimeType: string;
					theme?: Types.UiTheme | null;
					url: string;
					width: number;
				}>;
		  }
		| {
				__typename?: "GenericAsset";
				id: string;
				idInternal: number;
				pid: string;
				symbol: string;
				name: string;
				price: { value: string; precision: number };
				logos: Array<{
					__typename?: "Image";
					height: number;
					mimeType: string;
					theme?: Types.UiTheme | null;
					url: string;
					width: number;
				}>;
		  }
		| {
				__typename?: "IndexAsset";
				id: string;
				idInternal: number;
				pid: string;
				symbol: string;
				name: string;
				price: { value: string; precision: number };
				logos: Array<{
					__typename?: "Image";
					height: number;
					mimeType: string;
					theme?: Types.UiTheme | null;
					url: string;
					width: number;
				}>;
		  }
		| {
				__typename?: "LeverageAsset";
				id: string;
				idInternal: number;
				pid: string;
				symbol: string;
				name: string;
				price: { value: string; precision: number };
				logos: Array<{
					__typename?: "Image";
					height: number;
					mimeType: string;
					theme?: Types.UiTheme | null;
					url: string;
					width: number;
				}>;
		  }
		| {
				__typename?: "MetalAsset";
				id: string;
				idInternal: number;
				pid: string;
				symbol: string;
				name: string;
				price: { value: string; precision: number };
				logos: Array<{
					__typename?: "Image";
					height: number;
					mimeType: string;
					theme?: Types.UiTheme | null;
					url: string;
					width: number;
				}>;
		  }
		| {
				__typename?: "SecurityTokenAsset";
				id: string;
				idInternal: number;
				pid: string;
				symbol: string;
				name: string;
				price: { value: string; precision: number };
				logos: Array<{
					__typename?: "Image";
					height: number;
					mimeType: string;
					theme?: Types.UiTheme | null;
					url: string;
					width: number;
				}>;
		  }
		| {
				__typename?: "StockAsset";
				id: string;
				idInternal: number;
				pid: string;
				symbol: string;
				name: string;
				price: { value: string; precision: number };
				logos: Array<{
					__typename?: "Image";
					height: number;
					mimeType: string;
					theme?: Types.UiTheme | null;
					url: string;
					width: number;
				}>;
		  }
		| null;
};

export const GetAssetGenericDocument = gql`
	query GetAssetGeneric($input: AssetInput!) {
		asset(input: $input) {
			id
			idInternal
			pid
			symbol
			name
			price
			logos {
				height
				mimeType
				theme
				url
				width
			}
			... on EquityEtcAsset {
				exchangeId
				metrics {
					isin
				}
			}
			... on EquityEtfAsset {
				exchangeId
				metrics {
					isin
				}
			}
			... on EquityStockAsset {
				exchangeId
				metrics {
					isin
				}
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class GetAssetGenericGQLService extends Apollo.Query<GetAssetGenericQuery, GetAssetGenericQueryVariables> {
	document = GetAssetGenericDocument;
	client = "bff";
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
